import React, { Component } from 'react'

class SearchItemTeamStatus extends Component {
	getPostTeamStatus = () => {
		// Validation robuste des props
		if (!this.props.postItem || typeof this.props.postItem !== 'object') {
			return ''
		}

		try {
			if (this.props.postItem.highlight && this.props.postItem.highlight.post_team_status) {
				return String(this.props.postItem.highlight.post_team_status)
			} else if (this.props.postItem._source && this.props.postItem._source.post_team_status) {
				return String(this.props.postItem._source.post_team_status)
			}
		} catch (error) {
			// Gestion gracieuse des erreurs
			console.warn('Erreur lors de la récupération du statut de l\'équipe:', error)
		}
		
		return ''
	}

	getPostTeamStatusClass = () => {
		if (this.props.postItemMini) {
			return 'search-list-item-fonction search-list-mini-item-fonction'
		}
		return 'search-list-item-fonction'
	}

	render = () => {
		const teamStatus = this.getPostTeamStatus()
		
		// Ne rendre que si le statut existe
		if (!teamStatus) {
			return null
		}

		return (
			<p 
				className={this.getPostTeamStatusClass()}
				role="text"
				aria-label={`Statut de l'équipe: ${teamStatus}`}
			>
				{teamStatus}
			</p>
		)
	}
}

export default SearchItemTeamStatus;
